(() => {
  const isTouch = window.matchMedia(
    "(hover: none) and (pointer: coarse)",
  ).matches;
  if (!isTouch) return;

  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;

    const card = target.closest(".card-flip-card") as HTMLElement | null;
    if (!card) return;

    // Klick auf echte interaktive Elemente soll NICHT flippen
    if (target.closest("a, button, input, textarea, select, label")) return;

    card.classList.toggle("is-flipped");
  });
})();
